import { useState, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ApiProvider, RealtimeProvider, ToastProvider } from '@saas/ui';
import { api } from '../api/client.js';
import { AuthProvider } from '../api/auth.js';
import { createQueryClient } from '../api/queries.js';
import { useRealtime } from '../api/realtime.js';
import { router } from './router.js';

/** realtime gateway への接続（ログイン後に 1 本）。AuthProvider と QueryClientProvider の内側に置く */
function RealtimeRoot({ children }: { children: ReactNode }) {
  const bus = useRealtime();
  return <RealtimeProvider value={bus}>{children}</RealtimeProvider>;
}

export function App() {
  const [queryClient] = useState(createQueryClient);
  return (
    <QueryClientProvider client={queryClient}>
      <ApiProvider client={api}>
        <AuthProvider
          onLoggedOut={() => {
            const here = router.state.location;
            // 招待の受諾画面（/invite/<token>）は、ログアウトしてそのまま続けられるように残す
            if (!here.pathname.startsWith('/login') && !here.pathname.startsWith('/signup') && !here.pathname.startsWith('/invite/')) {
              void router.navigate(`/login?next=${encodeURIComponent(here.pathname + here.search)}`, { replace: true });
            }
          }}
        >
          <RealtimeRoot>
            <ToastProvider>
              <RouterProvider router={router} />
            </ToastProvider>
          </RealtimeRoot>
        </AuthProvider>
      </ApiProvider>
    </QueryClientProvider>
  );
}
